import  axiosClient  from "../Network/apiClient"
const ObservationService = {

    getObservations: (year) => {
        return axiosClient.get('/observations?'+ (year ? "year=" + year : ''));
    },
    getObservation: (id) => {
        return axiosClient.get('/observations/' + id);
    },
    updateObservation: (obs) =>  {
        if (obs.id > 0)
            return axiosClient.put(`/observations/${obs.id}`,JSON.stringify(obs));
        else
            return axiosClient.post('/observations', JSON.stringify(obs));
    },
    deleteObservation: (obs) =>  {
        return axiosClient.delete(`/observations/${obs.id}`);
    },

}

export default ObservationService
